const getContextWindow = ({ current }) => {
  return current ? current.ownerDocument.defaultView : null;
};
export {
  getContextWindow
};
//# sourceMappingURL=get-context-window.js.map
